import { makeUrl } from './url'

const imageMuxUrl = 'https://image.mux.com'
const videoMuxUrl = 'https://stream.mux.com'

const videoExtension = 'm3u8'

export const getAssetIdFromUrl = url =>
    url
        .split(`${videoMuxUrl}/`)
        .pop()
        .split('.')[0]

export const getVideoUrl = playbackId => `${videoMuxUrl}/${playbackId}.${videoExtension}`

export const getThumbnailUrl = (
    playbackId,
    options = {
        extension: 'jpg',
    },
) => {
    const { extension = 'jpg', ...restOptions } = options

    return makeUrl(`${imageMuxUrl}/${playbackId}/thumbnail.${extension}`, restOptions)
}

export const getGiflUrl = (playbackId, options) => makeUrl(`${imageMuxUrl}/${playbackId}/animated.gif`, options)
